import { LineStyle } from 'lightweight-charts';

/** Niveles (precio) de stop loss / profit de la operación abierta; null = no activo en el modelo. */
export interface OpenTradeLevels {
  stoploss: number | null;
  profit: number | null;
}

/**
 * Líneas horizontales SL/TP de la última entrada sin salida, como referencia de dónde va a salir.
 * Quita las líneas previas (`prev`) y crea las nuevas (solo valores finitos > 0); devuelve las
 * creadas para poder quitarlas en la siguiente llamada.
 */
export function applyOpenTradeLines(series: any, prev: any[], levels: OpenTradeLevels | null): any[] {
  for (const line of prev || []) {
    // La serie puede haberse recreado (cambio de tipo de gráfico): la línea ya no existe en ella.
    try { series?.removePriceLine(line); } catch {}
  }
  if (!series || !levels) return [];

  const lines: any[] = [];
  const add = (price: number | null, color: string, title: string) => {
    if (price == null || !Number.isFinite(price) || price <= 0) return;
    try {
      lines.push(series.createPriceLine({
        price, color, lineWidth: 1, lineStyle: LineStyle.Dashed, axisLabelVisible: true, title,
      }));
    } catch {}
  };
  add(levels.stoploss, '#ef5350', 'SL');
  add(levels.profit, '#26a69a', 'TP');
  return lines;
}
